module.exports = __webpack_public_path__ + "static/images/props-fail.8c6fa20.png";